import { render, staticRenderFns } from "./ScrollSelector.vue?vue&type=template&id=6b314ecf&scoped=true&"
import script from "./ScrollSelector.vue?vue&type=script&lang=js&"
export * from "./ScrollSelector.vue?vue&type=script&lang=js&"
import style0 from "./ScrollSelector.vue?vue&type=style&index=0&id=6b314ecf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b314ecf",
  null
  
)

export default component.exports